import http from '@/utils/request'

const apis = {
  // =======================
  // 登录
  login(username, password) {
    return http.post({
      url: '/pc/login',
      data: {
        username,
        password
      }
    })
  },
  VillageAgrilogin(dto) {
    return http.get({
      url: '/production_webservice/productionWork/getSysVillageAgriId',
      data: dto
    })
  },
  updatePassword(oldPassword, newPassword) {
    return http.post({
      url: '/pc/updatePassword',
      data: {
        oldPassword,
        newPassword
      }
    })
  },
  getWeather(data) {
    return http.get({
      url: '/pc/index/getWeather',
      data: {
        ...data
      }
    })
  },
  getHfPreWeather(data) {
    return http.get({
      url: '/pc/index/getHfPreWeather',
      data: {
        ...data
      }
    })
  },
  getAlarmList() {
    return http.get({
      url: '/pc/index/getAlarmList',
      data: {}
    })
  },
  getGrowthModelStages(name, cropld, id, remark, updateId, updateTime) {
    return http.get({
      url: '/pc/growthModel/getGrowthModelStages',
      data: {
        name,
        cropld,
        id,
        remark,
        updateId,
        updateTime
      }
    })
  },
  // ===============================用户管理
  // PC 查询用户列表
  sysUserList(pageNum, pageSize, roleId, status, username, companyId) {
    return http.get({
      url: '/pc/sysUser/getUserList',
      data: {
        pageNum,
        pageSize,
        roleId,
        status,
        username,
        companyId
      }
    })
  },
  getNumericalAttributeList(pageNum, pageSize, status, token) {
    return http.get({
      url: '/pc/objDeviceNumerical/getNumericalAttributeList',
      data: {
        pageNum,
        pageSize,
        status,
        token
      }
    })
  },
  getSysUserByToken(token) {
    return http.get({
      url: '/pc/sysUser/getSysUserByToken',
      data: {
        token
      }
    })
  },
  getDataHisDataChart(attributeId, eid, startDate, endDate, dateType) {
    return http.get({
      url: '/pc/dataStatistics/getDataHisDataChart',
      data: {
        attributeId,
        eid,
        startDate,
        endDate,
        dateType
      }
    })
  },
  sendAlarmSetToBox(id) {
    return http.post({
      url: '/pc/objDeviceAttributeAlarm/sendAlarmSetToBox',
      typea: 1,
      data: {
        id: id
      }
    })
  },
  // 冻结put请求
  putInfo(url, id, date) {
    return http.post({
      url: url,
      typea: 1,
      data: {
        id: id,
        date: date,
        _method: 'put'
      }
    })
  },
  putTwoInfo(dto) {
    return http.put({
      url: `/pc/sysUser/updateUserStatus`,
      typea: 1,
      data: dto
    })
  },
  // 添加、编辑
  saveUserInfo(dto) {
    return http.post({
      url: '/pc/sysUser/saveUserInfo',
      typea: 1,
      data: dto
    })
  },
  // 通过ID 查询用户信息
  sysUserItem(id) {
    return http.get({
      url: '/pc/sysUser/getUserInfo',
      data: {
        id
      }
    })
  },
  // 冻结/启用用户
  updateUserS(id) {
    return http.get({
      url: '/pc/sysUser/updateUserStatus',
      data: {
        id
      }
    })
  },
  //公用删除
  delfun(url, id, date) {
    return http.post({
      url: url,
      data: {
        id: id,
        date: date,
        _method: 'delete'
      }
    })
  },
  delfunTwo(url, id, date) {
    return http.post({
      url: url,
      data: {
        ids: id,
        date: date,
        _method: 'delete'
      }
    })
  },
  // 获取本公司下所有角色
  getAllRoles() {
    return http.get({
      url: '/pc/sysRole/getAllRoles',
      data: {}
    })
  },

  // 获取公司下用户
  getComAllUser(companyId) {
    return http.get({
      url: `/pc/sysUser/getUsersByCompanyId/${companyId}`,
      data: {
        companyId
      }
    })
  },

  // 根据公司ID 查询 角色列表
  getComAllRoles(companyId) {
    return http.get({
      url: `/pc/sysRole/getRolesByCompanyId/${companyId}`,
      data: {
        companyId
      }
    })
  },
  // 获取公司主账号
  getComAcction(id) {
    return http.get({
      url: `/pc/sysUser/getUserByCompanyId`,
      data: {
        id
      }
    })
  },
  // ===============================系统设置
  sysSetItem(id, companyId, pollingHandoverInterval, totalCallInterval, remark) {
    return http.post({
      url: `/pc/sysSet/saveSysSet`,
      typea: 1,
      data: {
        id,
        companyId,
        pollingHandoverInterval,
        totalCallInterval,
        remark
      }
    })
  },
  // 获取当前公司的系统设置
  getSysSetInfo(companyId) {
    return http.get({
      url: `/pc/sysSet/getSysSetInfo/${companyId}`,
      data: {
        companyId
      }
    })
  },
  // ===============================角色管理
  // 查询所有公司
  getAllCompanys() {
    return http.get({
      url: '/pc/companyInfo/getAllCompanys',
      data: {}
    })
  },
  // 角色分页
  getRoleList(pageNum, pageSize, companyId, name) {
    return http.get({
      url: '/pc/sysRole/getRoleList',
      data: {
        pageNum,
        pageSize,
        companyId,
        name
      }
    })
  },

  // 通过ID查询角色信息
  getRoleInfoById(id) {
    return http.get({
      url: '/pc/sysRole/getRoleInfoById',
      data: {
        id
      }
    })
  },
  // 保存角色信息
  saveRoleInfo(role) {
    return http.post({
      url: `/pc/sysRole/saveRoleInfo`,
      typea: 1,
      data: role
    })
  },

  // 保存角色信息
  // updatePassword(oldPassword, newPassword) {
  // 	return http.post({
  // 		url: `/pc/sysUser/updatePassword`,
  // 		typea: 1,
  // 		data: {
  // 			oldPassword,
  // 			newPassword,
  // 		}
  // 	})
  // },

  // *******************************用户管理*******************************
  //用户管理列表
  getUserMessageList(pageNum, pageSize, departId, email, id, name, nick, phone, qq, roleId, sex, status, username) {
    return http.get({
      url: '/pc/sysUser/list',
      data: {
        pageNum, //第几页，默认1
        pageSize, //默认展示多少条，默认10
        departId, //机构id
        email, //邮箱地址,
        id, //主键id
        name, //真实姓名
        nick, //昵称
        phone, //手机号
        qq, //qq
        roleId, //角色id
        sex, // 性别0男1女
        status, //状态（0启用，1冻结）
        username //账号
      }
    })
  },

  // /新增用户
  newUsersData(username, roleId, nick, departId, password, realName, gender, mobile, email, qq, accountType, id) {
    return http.post({
      url: '/pc/sysUser/saveUser',
      data: {
        username, //账号
        roleId, // 角色
        nick, // 昵称
        departId, // 组织机构
        password, //密码
        realName, //姓名
        gender, //性别
        mobile, //手机号
        email, //邮箱
        qq,
        accountType,
        id
      }
    })
  },
  //冻结 启动
  setfrozen(id) {
    return http.post({
      url: '/pc/sysUser/updateSysUserStatus',
      data: {
        id
      }
    })
  },
  //获取用户详情
  getUserDetails(id) {
    return http.get({
      url: '/pc/sysUser/info',
      data: {
        id
      }
    })
  },
  //获取全部角色
  getAllSysRole() {
    return http.get({
      url: '/pc/sysRole/getAllSysRole',
      data: {}
    })
  },
  //获取组织机构
  getDepartList() {
    return http.get({
      url: '/pc/sysDepart/getDepartTree'
    })
  },

  // *******************************用户管理结束*******************************
  // *******************************角色管理*******************************
  getRoleMessageList(pageNum, pageSize, name) {
    return http.get({
      url: '/pc/sysRole/getRoleList',
      data: {
        pageNum,
        pageSize,
        name
      }
    })
  },
  getRoleMenus(data) {
    return http.get({
      url: '/pc/sysRole/getAiRoleMenus',
      data: {
        ...data
      }
    })
  },
  getAiUserRoleMenus(data) {
    return http.get({
      url: '/pc/sysRole/getAiUserRoleMenus',
      data: {
        ...data
      }
    })
  },

  getUserRoleMenus(data) {
    return http.get({
      url: '/pc/sysRole/getUserRoleMenus',
      data: {
        ...data
      }
    })
  },
  // 新增用户
  saveRoleMenus(data) {
    return http.post({
      url: '/pc/sysRole/saveAiRoleMenus',
      data: {
        ...data
      },
      typea: 1
    })
  },

  // 新增用户
  addRoleMessageList(describes, name, id) {
    return http.post({
      url: '/pc/sysRole/saveSysRole',
      data: {
        describes, //描述
        name, //角色名称
        id //主键id
      }
    })
  },
  //编辑获取数据
  getsetRoleMessageList(id) {
    return http.get({
      url: '/pc/sysRole/info',
      data: {
        id //主键id
      }
    })
  },

  // *******************************角色管理结束*******************************

  //查询系统消息列表
  getSystemMessageList(pageNum, pageSize, endTime, startTime, title, type) {
    return http.get({
      url: '/pc/sysMessage/list',
      data: {
        pageNum, //第几页，默认1
        pageSize, //默认展示多少条，默认10
        endTime,
        startTime,
        title, //标题
        type //消息类型（0设备消息，1系统公告）
      }
    })
  },
  // *******************************系统信息结束*******************************
  // 查询组织机构树，查询1
  getsysDepartMessageList(pageNum, pageSize) {
    return http.get({
      url: '/pc/sysDepart/getDepartTree',
      data: {
        pageNum, //第几页，默认1
        pageSize //默认展示多少条，默认10
      }
    })
  },
  //保存组织机构
  newSaveDepart(name, parentId, describes, id, remark) {
    return http.post({
      url: '/pc/sysDepart/saveDepart',
      data: {
        name, //机构名称
        parentId, //上级机构（无上级为0）
        describes, //机构描述
        id,
        remark //备注
      }
    })
  },
  //编辑是获取信息
  getMessageEdit(id) {
    return http.get({
      url: '/pc/sysDepart/info',
      data: {
        id // 主键id ，根据具体业务进行判定
      }
    })
  },
  // *******************************组织机构结束*******************************
  //查询系统日志列表
  getsysLogList(pageNum, pageSize, parentId, endTime, startTime, type, username) {
    return http.get({
      url: '/pc/sysLog/list',
      data: {
        pageNum, //第几页，默认1
        pageSize, //默认展示多少条，默认10
        parentId, //上级机构（无上级为0）
        endTime, //结束时间
        startTime, //开始时间
        type, //类型（0操作日志，1定时任务）
        username //操作员id
      }
    })
  },

  // *******************************系统日志结束*******************************
  //查询审批模板列表
  geTapproveTemplate(pageNum, pageSize, title, id) {
    return http.get({
      url: '/pc/approveTemplate/list',
      data: {
        pageNum, //第几页，默认1
        pageSize, //默认展示多少条，默认10
        title, //标题
        id
      }
    })
  },
  //新增保存审批模板
  addSaveApproveTemplate(id, list, remark, title, updateId, updateTime) {
    return http.post({
      url: '/pc/approveTemplate/saveApproveTemplate',
      typea: 1,
      data: {
        id,
        list, //审批模板详情表(对象)
        remark, //备注
        title, //标题
        updateId, //创建修改人员id
        updateTime //创建修改时间
      }
    })
  },
  //查询审批模板详情
  getapproveTemplateEdit(pageNum, pageSize, id, title) {
    return http.get({
      url: '/pc/approveTemplate/info',
      data: {
        pageNum, //第几页，默认1
        pageSize, //默认展示多少条，默认10
        id, //详情id（查询详情时使用））
        title //标题
      }
    })
  },
  //   查询所有用户
  getAllSysUser() {
    return http.get({
      url: '/pc/sysUser/getAllSysUser',
      data: {}
    })
  },
  // *******************************审批模板结束*******************************
  //查询审批配置
  getApproveSet(pageNum, pageSize) {
    return http.get({
      url: '/pc/approveSet/list',
      data: {
        pageNum, //第几页，默认1
        pageSize //默认展示多少条，默认10
      }
    })
  },
  // 编辑获取详情

  getapproveSetEdit(id, pageNum, pageSize) {
    return http.get({
      url: '/pc/approveSet/info',
      data: {
        id, //键id ，根据具体业务进行判定
        pageNum, //第几页，默认1
        pageSize //默认展示多少条，默认10
      }
    })
  },
  //新增保存审批配置
  saveApproveSet(dto) {
    return http.post({
      url: '/pc/approveSet/saveApproveSet',
      data: dto
    })
  },
  //查询全部审批模板
  getAllApproveTemplate() {
    return http.get({
      url: '/pc/approveTemplate/getAllApproveTemplate',
      data: {}
    })
  },

  // *******************************审批配置结束*******************************
  //查询审批记录列表
  getgetDataHisApproveList(pageNum, pageSize, approveResult, approveScene, approveTemplateId, approveUserName, endTime, startTime) {
    return http.get({
      url: '/pc/dataHisApprove/getDataHisApproveList',
      data: {
        pageNum, //第几页，默认1
        pageSize, //默认展示多少条，默认10
        approveResult, //审批结果（0失败，1成功）
        approveScene, //审批场景
        approveTemplateId, //审批模板id
        approveUserName, //审批人
        endTime, //结束时间
        startTime //开始时间
      }
    })
    // getNumericalAttributeList(pageNum,pageSize,status){
    // 	return http.get({
    // 		url: '/obj/deviceNumerical/getNumericalAttributeList',
    // 		 data: {
    // 			pageNum,//第几页，默认1
    // 			pageSize,//默认展示多少条，默认10
    // 			status

    // 		 }
    // 	})

    // },
  },
  // *******************************审批记录结束*******************************
  //查询农作物列表
  getGrowthCropList(pageNum, pageSize, groupId, id, image, name) {
    return http.get({
      url: '/pc/growthCrop/getGrowthCropList',
      data: {
        pageNum, //第几页，默认1
        pageSize, //默认展示多少条，默认10
        groupId, //分组name
        id, //
        image, //图片
        name //名称
      }
    })
  },

  // // 保存农作物
  // saveGrowthCrop(id,image,name,modelId){
  // 	return http.post({
  // 		url: '/pc/growthCrop/saveGrowthCrop',
  // 	    typea:1,
  // 		 data: {
  // 		    id,//
  // 			image,//图片
  // 			name,//名称
  // 			modelId,//生长模型id

  //     }
  // 	})
  // 保存农作物
  saveGrowthCrop(dto) {
    return http.post({
      url: '/pc/growthCrop/saveGrowthCrop',
      typea: 1,
      data: dto
    })
  },
  //查询农作物详情
  getGrowthCrop(id, pageNum, pageSize) {
    return http.get({
      url: '/pc/growthCrop/getGrowthCrop',
      data: {
        id, // 主键id ，根据具体业务进行
        pageNum, //第几页，默认1
        pageSize //默认展示多少条，默认10
      }
    })
  },
  //查询全部农作物
  getAllGrowthCrops() {
    return http.get({
      url: '/pc/growthCrop/getGrowthCrops',
      data: {}
    })
  },
  //获取生长作物价格记录
  getGrowthCropIncomeData(data) {
    return http.get({
      url: '/pc/growthCropIncomeData/getGrowthCropIncomeData',
      data: data
    })
  },

  //获取生长作物价格记录列表
  getGrowthCropIncomeDataList(data) {
    return http.get({
      url: '/pc/growthCropIncomeData/getGrowthCropIncomeDataList',
      data: data
    })
  },
  saveGrowthCropIncomeData(dto) {
    return http.post({
      url: '/pc/growthCropIncomeData/saveGrowthCropIncomeData',
      typea: 1,
      data: dto
    })
  },
  //获取生长作物价格记录
  getGrowthCropPriceData(data) {
    return http.get({
      url: '/pc/GrowthCropPriceData/getGrowthCropPriceData',
      data: data
    })
  },

  //获取生长作物价格记录列表
  getGrowthCropPriceDataList(data) {
    return http.get({
      url: '/pc/GrowthCropPriceData/getGrowthCropPriceDataList',
      data: data
    })
  },
  saveGrowthCropPriceData(dto) {
    return http.post({
      url: '/pc/GrowthCropPriceData/saveGrowthCropPriceData',
      typea: 1,
      data: dto
    })
  },
  // 查询 区域——分组 二级列表(种植分组下拉)
  getGroupList() {
    return http.get({
      url: `/pc/growthCrop/getGroupList`,
      data: {}
    })
  },
  // *******************************农作物结束*******************************
  //查询决策模型列表
  getDecisionModelList(pageNum, pageSize, groupName, id, image, name) {
    return http.get({
      url: '/pc/growthCrop/getDecisionModelList',
      data: {
        pageNum, //第几页，默认1
        pageSize, //默认展示多少条，默认10
        groupName, //分组name
        id, //
        image, //
        name
      }
    })
  },
  //  保存决策模型
  saveDecisionModel(bto) {
    return http.post({
      url: '/pc/growthCrop/saveDecisionModel',
      typea: 1,
      data: bto
    })
  },
  // 查询全部生长模型列表
  growthModellistAll(pageNum, pageSize, groupId, id, image, name) {
    return http.get({
      url: '/pc/growthModel/list',
      data: {
        pageNum, //第几页，默认1
        pageSize, //默认展示多少条，默认10
        groupId, //分组id
        id, // 主键
        image, //图片
        name //名称
      }
    })
  },
  // 查询所有生长阶段
  getGrowthModelStagesAll(id) {
    return http.get({
      url: '/pc/growthCrop/getGrowthModelStages',
      data: {
        id //主键id ，根据具体业务进行判定
      }
    })
  },

  // *******************************决策模型结束*******************************
  // *******************************生长模型开始*******************************
  // 查询全部生长模型列表
  growthModelist(pageNum, pageSize, groupId, name) {
    return http.get({
      url: '/pc/growthModel/list',
      data: {
        pageNum, //第几页，默认1
        pageSize, //默认展示多少条，默认10
        groupId, // 分组Id
        name // 生长模型名称
      }
    })
  },
  //  查询生长模型详情
  growthModelInfo(modelId) {
    return http.get({
      url: '/pc/growthModel/info',
      data: {
        modelId //生长模型id
      }
    })
  },
  //查询历史生长模型列表
  getHisGrowthModelList(pageNum, pageSize, cropId, id, remark, updateId, updateTime) {
    return http.get({
      url: '/pc/growthModel/getHisGrowthModelList',
      data: {
        pageNum, //第几页，默认1
        pageSize, //默认展示多少条，默认10
        cropId, //作物id
        id, // 主键id ，根据具体业务进
        remark, //图片
        name, //名称
        updateId, //创建修改人员id
        updateTime //创建修改时间
      }
    })
  },
  // 生长模型阶段数据 导出
  exportExcel(modelId, stageId) {
    return http.post({
      url: '/pc/growthModelData/exportExcel',
      data: {
        modelId, //生长模型id
        stageId //生长阶段id
      }
    })
  },
  //查询生长模型详情
  growthModelTime(modelId) {
    return http.get({
      url: '/pc/growthModel/info',
      data: {
        modelId
      }
    })
  },

  // *******************************生长模型结束*******************************
  // *******************************设备分组开始*******************************
  //查询设备分组树，查询1
  getConfigGroupTree(id) {
    return http.get({
      url: '/pc/configGroup/getConfigGroupTree',
      data: {
        id //主键id ，根据具体业务进行判定
      }
    })
  },
  // 查询一级和二级分组
  getConfigGroupOneAndTwo(dto) {
    return http.get({
      url: '/pc/configGroup/getConfigGroupOneAndTwo',
      data: dto
    })
  },
  // 保存分组
  saveConfigGroup(dto) {
    return http.post({
      url: '/pc/configGroup/saveConfigGroup',
      data: dto
    })
  },
  //查询设备分组
  getConfigGroup(dto) {
    return http.get({
      url: '/pc/configGroup/getConfigGroup',
      data: dto
    })
  },

  // *******************************设备分组结束*******************************
  //查询传感器列表
  getNumericalList(pageNum, pageSize, code, groupId, name) {
    return http.get({
      url: '/pc/objDeviceNumerical/getNumericalList',
      data: {
        pageNum, //第几页，默认1
        pageSize, //默认展示多少条，默认10
        code, //设备编码
        groupId, //分组id
        name //设备名称
      }
    })
  },
  getModelRuleAttributes1(eid) {
    return http.get({
      url: '/pc/objDeviceAttributeAlarm/getModelRuleAttributes',
      data: {
        eid
      }
    })
  },
  // 获取历史数据列表
  getDataHisDataList(startDate, endDate, attributeId, dateType, eid, pageNum, pageSize) {
    return http.get({
      url: '/pc/dataStatistics/getDataHisDataList',
      data: {
        startDate,
        endDate,
        attributeId,
        dateType,
        eid,
        pageNum,
        pageSize
      }
    })
  },
  // 启用/停用
  onOrOffNumerical(id) {
    return http.post({
      url: '/pc/objDeviceNumerical/openOrCloseNumerical',
      data: {
        id
      }
    })
  },
  // 保存传感器
  saveNumerical(bto) {
    return http.post({
      url: '/pc/objDeviceNumerical/saveNumerical',
      typea: 1,
      data: bto
    })
  },
  // 查询全部设备类型模板
  getModelRuleDevices(type) {
    return http.get({
      url: '/pc/modelRuleDevice/getModelRuleDevices',
      data: {
        type
      }
    })
  },
  //查询传感器详情
  getNumerical(id) {
    return http.get({
      url: '/pc/objDeviceNumerical/getNumerical',
      data: {
        id //主键id ，根据具体业务进行判定(编辑id)
      }
    })
  },
  //  查询全部通信网关
  getGateways() {
    return http.get({
      url: '/pc/objDeviceGateway/getGateways',
      data: {}
    })
  },

  // *******************************传感器结束*******************************
  //查询摄像头列表
  getVideoList(pageNum, pageSize, code, groupId, name) {
    return http.get({
      url: '/pc/objDeviceVideo/getVideoList',
      data: {
        pageNum, //第几页，默认1
        pageSize, //默认展示多少条，默认10
        code, //设备编码
        groupId, //所属分组
        name //设备名称
      }
    })
  },
  //  启用/停用
  openOrCloseVideo(id) {
    return http.post({
      url: '/pc/objDeviceVideo/openOrCloseVideo',
      data: {
        id //主键id ，根据具体业务进行判定
      }
    })
  },
  // 查询摄像头详情
  getVideo(id) {
    return http.get({
      url: '/pc/objDeviceVideo/getVideo',
      data: {
        id //主键id ，根据具体业务进行判定
      }
    })
  },
  //查询全部生长模型列表
  getGrowthModels(pageNum, pageSize, groupId, id, image, name) {
    return http.get({
      url: '/pc/growthModel/list',
      data: {
        pageNum,
        pageSize,
        groupId,
        id,
        image,
        name
      }
    })
  },
  //查询决策模型列表详情
  getDecisionModelListDefi(id) {
    return http.get({
      url: '/pc/growthCrop/getGrowthCrop',
      data: {
        id
      }
    })
  },
  //保存摄像头
  saveVideo(bto) {
    return http.post({
      url: '/pc/objDeviceVideo/saveVideo',
      typea: 1,
      data: bto
    })
  },
  // *******************************摄像头结束*******************************
  //询控制设备列表
  getSwitchList(pageNum, pageSize, code, groupId, name) {
    return http.get({
      url: '/pc/objDeviceSwitch/getSwitchList',
      data: {
        pageNum,
        pageSize,
        code,
        groupId,
        name
      }
    })
  },
  //  启用/停用
  openOrCloseSwitch(id) {
    return http.post({
      url: '/pc/objDeviceSwitch/openOrCloseSwitch',
      data: {
        id //主键id ，根据具体业务进行判定
      }
    })
  },
  //  启用/停用
  openOrCloseSwitch_(data) {
    return http.post({
      url: '/pc/growthModelDecision/openOrCloseSwitch',
      typea: 1,
      data
    })
  },
  // 保存控制设备
  saveSwitch(bto) {
    return http.post({
      url: '/pc/objDeviceSwitch/saveSwitch',
      typea: 1,
      data: bto
    })
  },
  // 查询控制设备详情
  getSwitch(id) {
    return http.get({
      url: '/pc/objDeviceSwitch/getSwitch',
      data: {
        id
      }
    })
  },

  // *******************************控制设备结束*******************************
  //查询通信网关列表
  getGatewayList(pageNum, pageSize, gatewayCode, gatewayName, groupId) {
    return http.get({
      url: '/pc/objDeviceGateway/getGatewayList',
      data: {
        pageNum,
        pageSize,
        gatewayCode,
        gatewayName,
        groupId
      }
    })
  },
  //  启用/停用
  openOrCloseGateway(id) {
    return http.post({
      url: '/pc/objDeviceGateway/openOrCloseGateway',
      data: {
        id //主键id ，根据具体业务进行判定
      }
    })
  },
  //保存通信网关
  saveGateway(bto) {
    return http.post({
      url: '/pc/objDeviceGateway/saveGateway',
      data: bto
    })
  },
  // 查询控制设备详情
  getGatewayDER(id) {
    return http.get({
      url: '/pc/objDeviceGateway/getGateway',
      data: {
        id
      }
    })
  },

  // *******************************通信网关结束*******************************
  // 查询全部告警模板
  getModelAlarmSettingss() {
    return http.get({
      url: '/pc/modelAlarmSettings/getModelAlarmSettingss',
      data: {}
    })
  },
  // 查询全部传感器
  getNumericals() {
    return http.get({
      url: '/pc/objDeviceNumerical/getNumericals',
      data: {}
    })
  },
  // 查询全部传感器
  getNumericals2(groupId, paramType) {
    return http.get({
      url: '/pc/objDeviceNumerical/getNumericalsByGroupId',
      data: {
        groupId,
        paramType
      }
    })
  },
  // /查询告警模板列表
  getModelAlarmSettingsList(pageNum, pageSize, name) {
    return http.get({
      url: '/pc/modelAlarmSettings/getModelAlarmSettingsList',
      data: {
        pageNum,
        pageSize,
        name
      }
    })
  },
  // 保存告警模板
  saveModelAlarmSettings(bto) {
    return http.post({
      url: '/pc/modelAlarmSettings/saveModelAlarmSettings',
      typea: 1,
      data: bto
    })
  },
  // 保存告警模板
  saveUserGroup(bto) {
    return http.post({
      url: '/pc/sysUser/saveUserGroup',
      data: bto
    })
  },

  //查询告警模板详情
  getAlarmSettings(id) {
    return http.get({
      url: '/pc/modelAlarmSettings/getModelAlarmSettings',
      data: {
        id
      }
    })
  },
  // *******************************告警模板结束*******************************
  // 查询告警配置列表
  getObjDeviceAttributeAlarmList(pageNum, pageSize, attributeId, eid, modelAlarmSettingsId) {
    return http.get({
      url: '/pc/objDeviceAttributeAlarm/getObjDeviceAttributeAlarmList',
      data: {
        pageNum,
        pageSize,
        attributeId,
        eid,
        modelAlarmSettingsId
      }
    })
  },
  // 11查询全部属性名称
  getModelRuleAttributes(eid) {
    return http.get({
      url: '/pc/objDeviceAttributeAlarm/getModelRuleAttributes',
      data: {
        eid
      }
    })
  },
  // 查询全部控制设备
  getSwitchs() {
    return http.get({
      url: '/pc/objDeviceSwitch/getSwitchs',
      data: {}
    })
  },
  // 11查询全部属性名称(智慧控制)
  getAttributesBySwtichId(id) {
    return http.get({
      url: '/pc/objDeviceSwitch/getAttributesBySwtichId',
      data: {
        id
      }
    })
  },
  //保存告警配置
  saveObjDeviceAttributeAlarm(bto) {
    return http.post({
      url: '/pc/objDeviceAttributeAlarm/saveObjDeviceAttributeAlarm',
      typea: 1,
      data: bto
    })
  },
  // 查询告警配置详情
  getObjDeviceAttributeAlarm(id) {
    return http.get({
      url: '/pc/objDeviceAttributeAlarm/getObjDeviceAttributeAlarm',
      data: {
        id
      }
    })
  },
  // *******************************告警配置结束*******************************
  // 查询告警记录列表/
  getModelAttributeHisList(id, pageNum, pageSize) {
    return http.get({
      url: '/pc/dataAlarm/getDataRealAlarmList',
      data: {
        id, //分组id
        pageNum,
        pageSize
      }
    })
  },
  // *******************************告警记录结束*******************************
  // 查询告警统计

  getModelAttributeData(attributeId, eid, groupId, dateType, endDate, startDate) {
    return http.get({
      url: '/pc/dataAlarm/getDataHisAlarmChart',
      data: {
        attributeId, //属性id
        eid, //设备id
        groupId, //分组id
        dateType, //时间段类型（0最近10分钟、1最近20分钟、2最近30分钟、3昨天、4七天
        endDate, //结束日期，格式yyyy-MM-dd HH:mm:ss
        startDate //开始日期，格式yyyy-MM-dd HH:mm:ss
      }
    })
  },
  // 查询告警统计

  getDataHisAlarmList(attributeId, eid, groupId, dateType, endDate, startDate, pageNum, pageSize) {
    return http.get({
      url: '/pc/dataAlarm/getDataHisAlarmList',
      data: {
        attributeId, //属性id
        eid, //设备id
        groupId, //分组id
        dateType, //时间段类型（0最近10分钟、1最近20分钟、2最近30分钟、3昨天、4七天
        endDate, //结束日期，格式yyyy-MM-dd HH:mm:ss
        startDate, //开始日期，格式yyyy-MM-dd HH:mm:ss
        pageNum, //第几页，默认1
        pageSize //默认展示多少条，默认10
      }
    })
  },
  getDataHisAlarmChart(dto) {
    return http.post({
      url: '/pc/dataStatistics/getDataHisAlarmChart',
      data: dto,
      typea: 1
    })
  },
  // *******************************告警统计结束*******************************
  //查询智能控制属性列表
  getLinkageControlList(id, pageNum, pageSize) {
    return http.get({
      url: '/pc/linkageControl/getLinkageControlList',
      data: {
        id, //主键id ，根据具体业务进行判定
        pageNum, //第几页，默认1
        pageSize //默认展示多少条，默认10
      }
    })
  },
  // 查询定时条件、联动条件 (根据设备id)
  getLinkageControlInfoList(id) {
    return http.get({
      url: '/pc/linkageControl/getLinkageControlInfoList',
      data: {
        id //主键id ，根据具体业务进行判定
      }
    })
  },
  // 保存手动、定时、联动条件
  saveLinkageControl(bto) {
    return http.post({
      url: '/pc/linkageControl/saveLinkageControl',
      typea: 1,
      data: bto
    })
  },
  // 开启或关闭开关设备
  openOrCloseDeviceSwtich(bto) {
    return http.post({
      url: '/pc/linkageControl/openOrCloseDeviceSwtich',
      typea: 1,
      data: bto
    })
  },
  // 手动、定时、联动类型切换时 修改开关控制类型
  updateLinkageControlType(bto) {
    return http.post({
      url: '/pc/linkageControl/updateLinkageControlType',
      typea: 1,
      data: bto
    })
  },

  // *******************************/智能控制结束*******************************
  // 水肥一体化-灌溉记录 导出
  agriConfigBaseEquipmentExportExcel(id) {
    return http.post({
      url: '/pc/agriConfigBaseEquipment/exportExcel',
      data: {
        id
      }
    })
  },
  // 查询水肥一体化_灌溉记录列表
  getHisDataIrrigationList(id, pageNum, pageSize) {
    return http.get({
      url: '/pc/agriConfigWaterEquipment/getDataHisSwitchList',
      data: {
        id,
        pageNum,
        pageSize
      }
    })
  },
  // 保存水肥一体化_配比及执行动作
  saveConfigBaseEquipment(bto) {
    return http.post({
      url: '/pc/agriConfigBaseEquipment/saveConfigBaseEquipment',
      typea: 1,
      data: bto
    })
  },
  // 查询水肥一体化_水肥机列表
  getConfigBaseEquipmentList(pageNum, pageSize) {
    return http.get({
      url: '/pc/agriConfigBaseEquipment/getConfigBaseEquipmentList',
      data: {
        pageNum,
        pageSize
      }
    })
  },
  // 查询水肥一体化_配比及执行动作
  getConfigBaseEquipment(id) {
    return http.get({
      url: '/pc/agriConfigBaseEquipment/getConfigBaseEquipment',
      data: {
        id
      }
    })
  },
  // 水肥一体化手动、定时、联动类型切换
  updateControlType(bto) {
    return http.post({
      url: '/pc/agriConfigBaseEquipment/updateControlType',
      typea: 1,
      data: bto
    })
  },
  //查询水肥一体化_配比及执行动作_触发条件

  getToggleCondition(id) {
    return http.get({
      url: '/pc/agriConfigBaseEquipment/getToggleCondition',
      data: {
        id
      }
    })
  },

  // *******************************/水肥一体化结束*******************************水肥一体化

  // *******************************/决策模型*******************************水肥一体化
  getModelDecisionUpdateList(cropId, pageNum, pageSize, endTime, startTime, updateName) {
    return http.get({
      url: '/pc/growthCrop/getModelDecisionUpdateList',
      data: {
        cropId,
        pageNum,
        pageSize,
        endTime,
        startTime,
        updateName
      }
    })
  },

  // **************************************************************首页
  // 首页
  getNumericalAttributeList2(pageNum, pageSize, attributeName, deviceType, groupId, name, paramType, status) {
    return http.get({
      url: '/pc/objDeviceNumerical/getNumericalAttributeList',
      data: {
        pageNum,
        pageSize,
        attributeName,
        deviceType,
        groupId,
        name,
        paramType,
        status
      }
    })
  },
  // ************************************************************** 数据分析
  //  查询所有的区域
  getAreas() {
    return http.get({
      url: '/pc/dataStatistics/getAreas',
      data: {}
    })
  },
  // 查询区域下所有的分组
  getGreenhouse(id) {
    return http.get({
      url: '/pc/dataStatistics/getGreenhouse',
      data: {
        id
      }
    })
  },
  // 查询区域下所有的分组
  getGreenHouseList(id) {
    return http.get({
      url: '/pc/configGroupModel/getGreenHouseList',
      data: {
        id
      }
    })
  },
  // 查询分组模板
  getConfigModelList(id) {
    return http.get({
      url: '/pc/configGroupModel/getConfigModelList',
      data: {}
    })
  },
  saveGreenHouse(dto) {
    return http.post({
      url: '/pc/configGroupModel/saveGreenHouse',
      data: dto,
      typea: 1
    })
  },
  // 获取历史分析统计图表---- 数据分析
  getDataHisStatisticChart(dto) {
    return http.post({
      url: '/pc/dataStatistics/getDataHisStatisticChart',
      data: dto,
      typea: 1
    })
  },
  // 获取功耗统计图表---- 数据分析
  getDataPowerWasteChart(dto) {
    return http.post({
      url: '/pc/dataStatistics/getDataPowerWasteChart',
      data: dto,
      typea: 1
    })
  },
  // 查询分组下的所有传感器---- 数据分析
  getNumericalsByGroupId(id) {
    return http.get({
      url: '/pc/objDeviceNumerical/getNumericalsByGroupId',
      data: {
        id
      }
    })
  },
  //获取数据分析配置条件---- 数据分析
  getConfigDataAnalysis(type) {
    return http.get({
      url: '/pc/dataStatistics/getConfigDataAnalysis',
      data: {
        type
      }
    })
  },
  // 查询传感器设备属性列表---- 数据分析
  getNumericalAttributeListTwo(pageNum, pageSize, attributeName, deviceType, groupId, name, paramType, status) {
    return http.get({
      url: '/pc/objDeviceNumerical/getNumericalsByGroupId',
      data: {
        pageNum,
        pageSize,
        attributeName,
        deviceType,
        groupId,
        name,
        paramType,
        status
      }
    })
  },

  //查询所有生长阶段-- 首页
  getGrowthModelStageshome(id) {
    return http.get({
      url: '/pc/growthCrop/getGrowthModelStages',
      data: {
        id
      }
    })
  },
  listhome(pageNum, pageSize, groupId, id) {
    return http.get({
      url: '/pc/growthModel/list',
      data: {
        pageNum,
        pageSize,
        groupId,
        id
      }
    })
  },

  //保存设备离线配置
  saveDeviceAttributeOffline(dto) {
    return http.post({
      url: '/pc/objDeviceAttributeOffline/saveDeviceAttributeOffline',
      data: dto
    })
  },
  //查询设备离线配置列表
  getDeviceAttributeOfflineList(dto) {
    return http.get({
      url: '/pc/objDeviceAttributeOffline/getDeviceAttributeOfflineList',
      data: dto
    })
  },
  //查询设备离线配置详情
  getDeviceAttributeOffline(dto) {
    return http.get({
      url: '/pc/objDeviceAttributeOffline/getDeviceAttributeOffline',
      data: dto
    })
  },

  //保存提醒用户配置
  savePushUser(dto) {
    return http.post({
      url: '/pc/sysPushUser/savePushUser',
      data: dto
    })
  },
  //查询提醒用户配置列表
  getPushUserList(dto) {
    return http.get({
      url: '/pc/sysPushUser/getPushUserList',
      data: dto
    })
  },
  //查询提醒用户配置详情
  getPushUser(dto) {
    return http.get({
      url: '/pc/sysPushUser/getPushUser',
      data: dto
    })
  },
  getGreenHouseRealData(dto) {
    return http.get({
      url: '/pc/index/getGreenHouseRealData',
      data: dto
    })
  },
  getConfigGroupOne() {
    return http.get({
      url: '/pc/configGroup/getConfigGroupOne'
    })
  },

  // 获取分组类型列表
  getConfigGroupTypeList(dto) {
    return http.get({
      url: '/pc/configGroupType/getConfigGroupTypeList',
      data: dto
    })
  },

  // 查询告警配置详情
  getGrowthModelSetAlarm(dto) {
    return http.get({
      url: '/pc/growthModelSetAlarm/getGrowthModelSetAlarm',
      data: dto
    })
  },
  // 查询下发记录列表
  getGrowthModelSetAlarmHisDataList(dto) {
    return http.get({
      url: '/pc/growthModelSetAlarm/getGrowthModelSetAlarmHisDataList',
      data: dto
    })
  },
  // 查询全部告警配置（设备id）
  getGrowthModelSetAlarms(dto) {
    return http.get({
      url: '/pc/growthModelSetAlarm/getGrowthModelSetAlarms',
      data: dto
    })
  },
  // 获取用户下的设备
  getNumericalByUser(dto) {
    return http.get({
      url: '/pc/growthModelSetAlarm/getNumericalByUser',
      data: dto
    })
  },
  // 保存告警配置详情
  saveGrowthModelSetAlarm(dto) {
    return http.post({
      url: '/pc/growthModelSetAlarm/saveGrowthModelSetAlarm',
      data: dto,
      typea: 1
    })
  },
  // 任务下发（设备id）
  sendTask(dto) {
    return http.post({
      url: '/pc/growthModelSetAlarm/sendTask',
      data: dto,
      typea: 1
    })
  },
  // 获取全部分组类型列表
  getConfigGroupTypes(dto) {
    return http.get({
      url: '/pc/configGroupType/getConfigGroupTypes',
      data: dto
    })
  },

  // 获取分组类型
  getConfigGroupType(dto) {
    return http.get({
      url: '/pc/configGroupType/getConfigGroupType',
      data: dto
    })
  },

  // 保存分组类型
  saveConfigGroupType(dto) {
    return http.post({
      url: '/pc/configGroupType/saveConfigGroupType',
      data: dto,
      typea: 1
    })
  },

  // 删除分组类型
  delConfigGroupType(id) {
    return http.post({
      url: '/pc/configGroupType/delConfigGroupType',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },

  // 告警配置（启用/禁用）
  openOrCloseDeviceAttributeAlarm(dto) {
    return http.post({
      url: '/pc/objDeviceAttributeAlarm/changeIsOpen',
      data: dto,
      typea: 1
    })
  },

  // 获取系统用户列表
  getSysUserList(dto) {
    return http.get({
      url: '/pc/sysUser/list',
      data: dto
    })
  },
  // 获取系统用户
  getSysUser(dto) {
    return http.get({
      url: '/pc/sysUser/info',
      data: dto
    })
  },

  // 保存系统用户
  saveSysUser(dto) {
    return http.post({
      url: '/pc/sysUser/saveUser',
      data: dto
    })
  },

  // 删除系统用户
  delSysUser(id) {
    return http.post({
      url: '/pc/sysUser/delSysUser',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },

  // 启用禁用系统用户
  openOrCloseSysUser(dto) {
    return http.post({
      url: '/pc/sysUser/updateSysUserStatus',
      data: dto
    })
  },

  // 获取全部分组模型列表
  getConfigGroupModels(dto) {
    return http.get({
      url: '/pc/configGroupModel/getConfigGroupModels',
      data: dto
    })
  },
  // 查询历史生长模型列表
  getHisGrowthModelList(dto) {
    return http.get({
      url: '/pc/growthModel/getHisGrowthModelList',
      data: dto
    })
  },
  // 获取模型决策列表
  getGrowthModelDecisionList(dto) {
    return http.get({
      url: '/pc/growthModelDecision/getGrowthModelDecisionList',
      data: dto
    })
  },
  // 发送验证码
  sendCode(phone) {
    return http.post({
      url: '/pc/sendCode',
      typea: 1,
      data: JSON.stringify({
        phone
      })
    })
  },
  get7Weather(dto) {
    return http.get({
      url: '/pc/index/get7Weather',
      data: dto
    })
  },
  getHfPreWeather(dto) {
    return http.get({
      url: '/pc/index/getHfPreWeather',
      data: dto
    })
  },
  getAlarmPush(dto) {
    return http.get({
      url: '/pc/growthModelSetAlarm/getAlarmPush',
      data: dto
    })
  },

  getObjDeviceSwtichAttrVideoList(dto) {
    return http.get({
      url: '/pc/objDeviceSwtichAttrVideo/getObjDeviceSwtichAttrVideoList',
      data: dto
    })
  },
  getObjDeviceSwtichAttrVideo(dto) {
    return http.get({
      url: '/pc/objDeviceSwtichAttrVideo/getObjDeviceSwtichAttrVideo',
      data: dto
    })
  },
  saveObjDeviceSwtichAttrVideo(dto) {
    return http.post({
      url: '/pc/objDeviceSwtichAttrVideo/saveObjDeviceSwtichAttrVideo',
      data: dto,
      typea: 1
    })
  },
  // 启用禁用系统用户
  saveGrowthModelSetAlarmModel(dto) {
    return http.post({
      url: '/pc/growthModelSetAlarm/saveGrowthModelSetAlarmModel',
      data: dto,
      typea: 1
    })
  },
  // 验证码登录
  codeLogin(phone, code) {
    return http.post({
      url: '/pc/codeLogin',
      typea: 1,
      data: JSON.stringify({
        phone,
        code
      })
    })
  },
  // 启用禁用系统用户
  updateAlarmPush(dto) {
    return http.post({
      url: '/pc/growthModelSetAlarm/updateAlarmPush',
      data: dto,
      typea: 1
    })
  }
}
export default apis
